import { AxiosError } from 'axios';

import { axiosClient, deleteRequest, getWithParamsRequest, postRequest, putRequest } from '../utils/provider';
import { ApiResponse, transformError, transformSuccess } from '../utils/responseTransform';

export async function getPlaces(
  queryParams: QueryParams,
  signal?: AbortSignal
): Promise<ApiResponse<{ locations: Place[] }>> {
  return getWithParamsRequest('locations/search', queryParams, signal);
}

export async function getLocations(
  queryParams: QueryParamsForLocations,
  signal?: AbortSignal
): Promise<
  ApiResponse<{
    locations: AccountLocation[];
    meta?: { totalCount: number; totalUnfiltered?: number; totalPages?: number; page?: number; perPage?: number };
  }>
> {
  return getWithParamsRequest('locations', queryParams, signal);
}

export async function getLocationFilterOptions(
  queryParams: { q?: string; page?: number; perPage?: number },
  signal?: AbortSignal
): Promise<
  ApiResponse<{
    locations: LocationFilterOption[];
    meta?: { totalCount: number; page?: number; perPage?: number };
  }>
> {
  return getWithParamsRequest('locations/lookup', queryParams, signal);
}

export async function getLocationById(locationId): Promise<ApiResponse<{ accountLocation: AccountLocation }>> {
  // A 403/404 is expected here — validateStatus keeps it from tripping AxiosErrorBoundary.
  try {
    const response = await axiosClient.get(`/locations/${locationId}`, { validateStatus: (status) => status < 500 });

    if (response.status >= 400) {
      return { type: 'error', error: { errors: [] }, data: undefined };
    }

    return transformSuccess(response);
  } catch (error) {
    return transformError(error as AxiosError);
  }
}

export async function updateLocation(id, payload): Promise<ApiResponse<{ accountLocation: AccountLocation }>> {
  return putRequest(`locations/${id}`, payload);
}

export async function createLocation(payload): Promise<ApiResponse<{ id: number }>> {
  return postRequest('locations', payload);
}

export async function deleteLocation(id): Promise<ApiResponse> {
  return deleteRequest(`locations/${id}/soft_delete`);
}
